import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { MatIconButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs/operators';
import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { Flag } from '../../shared/flag/flag/flag';

@Component({
  selector: 'app-user-panel',
  templateUrl: './user-panel.html',
  styleUrl: './user-panel.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    AsyncPipe,
    TranslatePipe,
    MatIconButton,
    Flag,
  ],
})
export class UserPanel {
  private authService = inject(AuthService);
  private translateService = inject(TranslateService);
  account = this.authService.account;
  languages = this.translateService.getLangs();
  selectedLanguage = this.translateService.onLangChange.pipe(
    startWith({ lang: this.translateService.getCurrentLang() }),
    map(event => event.lang)
  );

  changeLanguage(lang: string): void {
    this.translateService.use(lang);
  }

  logout(): void {
    this.authService.logout();
  }
}
